export class AuthenticationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async changePassword(body) {
    return this.#http.post('/Authentication/ChangePassword', body);
  }
}
